<script lang="ts">
    import { createEventDispatcher } from 'svelte';
    import type { MultiSelectDefinition } from 'header/types';
    import { filter } from 'lodash-es';

    interface Props {
        field: MultiSelectDefinition;
    }

    let { field }: Props = $props();

    let options = $derived(field.options);
    let selected = $derived(field.value);

    const dispatch = createEventDispatcher();
    const onChange = (e: { currentTarget: HTMLSelectElement }) => {
        dispatch('change', {
            field: {
                ...field,
                value: filter(e.currentTarget.options, option => option.selected).map(
                    option => option.value,
                ),
            },
        });
    };
</script>

<select
    class="select"
    disabled={field.changeable === false}
    value={selected}
    onchange={onChange}
    multiple
>
    {#each options as { key, label } (key)}
        <option value={key} class:select__active={selected.includes(key)}>{label}</option>
    {/each}
</select>

<style lang="scss" scoped>
    .select {
        width: 100%;

        &__active {
            background-color: #cecece;
        }
    }
</style>
